import {Dropdown, Input, Modal} from 'antd'
import {course_getCourseClassStudents_Api} from 'apis'
import {getId} from 'apis/model/base'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import {createModalTitle} from 'components/renderFunctions/createModalTitle'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {AiOutlineAudit} from 'react-icons/ai'
import {BsPeopleFill, BsThreeDots} from 'react-icons/bs'
import {withProps} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {
    getGroupColor,
    getNameInitial,
    renderStudentCard
} from 'views/Workspace/Course/functions/renderCourseClassStudent'
import {FetchStudentById} from '../../components/FetchEntity'
import StudentViewCard from '../../Student/StudentViewCard'
import CourseClassContext from '../../CourseClassContext'
import {StudentActionTypes} from '../../index'
import {CourseClassStudentAttendantsForm} from '../CourseClassAttendanceForm'
import classNames from "classnames";
import {CourseClassStudentUpdateModal} from "../CourseClassStudentForm";
import {course_editStudentFromCourseClass_Api} from "../../../../../apis";
import {NotificationActionTypes, successNotify} from "../../../factory/createNotification";
import useAsyncAction from "../../../../../modules/asyncCache/useAsyncAction";
import {notifyOnError} from "../../../factory/createErrorEvent";
import {EntityPaginationMeta} from "../../../EntityList";
import {SubClassTags} from "../../components/SubClassTags";
import {FaFilter, FaIdCard} from "react-icons/fa6";
import getAliasName from "../../../../../helpers/getAliasName";
import LoadingBlock from "../../../../Loading/LoadingBlock";
import {BiSolidEdit} from "react-icons/bi";
import {TbTableOptions} from 'react-icons/tb'
import {CourseClassSummaryPanel} from '../../../../Workspace/Course/containers/CourseClassList/CourseClassSummaryPanel'
import {FiChevronsRight, FiMoreVertical} from "react-icons/fi";
import {RiSearchLine} from "react-icons/ri";

// Bảng học viên DÙNG CHUNG cho cả học viên và quản trị (trước đây 2 view khác nhau: card-list cho
// admin, table rời rạc cho học viên) - 2 cột đúng yêu cầu: [avatar+tên+mã học viên] / [Tổ/Nhóm/Đội],
// cột "xem chi tiết" (icon, không phải link chữ) + menu "..." (sửa thông tin/điểm danh) CHỈ hiện khi
// can_edit - không đổi permission, chỉ đổi UI hiển thị.
const renderStudentTableRow = ({can_edit, onViewDetail, renderContextMenu} = {}) => (item, index) => {
    const t = useTranslate()
    const {student, sub_class_name, role_code} = item ?? {}
    const {fullname, student_idcode, patron_saint_name} = student ?? {}
    const groupColor = getGroupColor(sub_class_name)
    const initial = getNameInitial(fullname)

    return (
        <tr key={index} className="border-t border-color-50 background hover:background-50 transition-all duration-300">
            <td className="px-3 py-2.5">
                <div className="flex items-center gap-2.5">
                    <div
                        style={{width: 32, height: 32, backgroundColor: groupColor, flexShrink: 0}}
                        className="rounded-full flex items-center justify-center">
                        <span className="text-white font-bold text-sm leading-none">{initial}</span>
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="font-semibold text-sm text-color-000 leading-snug truncate">
                            {patron_saint_name && (
                                <span className="mr-1 font-medium text-gray-600">
                                    {getAliasName(student, 'patron_saint')}
                                </span>
                            )}
                            {fullname}
                        </span>
                        <span className="font-mono text-2xs text-blue-500 truncate">
                            #{student_idcode}
                        </span>
                        {role_code === 'student_leader' && (
                            <span className="text-2xs font-medium text-secondary-500 italic tracking-wider">
                                {t('student_leader')}
                            </span>
                        )}
                    </div>
                </div>
            </td>
            <td className="px-3 py-2.5 text-center">
                {sub_class_name && (
                    <span
                        style={{backgroundColor: groupColor + '20', color: groupColor}}
                        className="px-2 py-0.5 rounded-full text-xs font-semibold whitespace-no-wrap">
                        {sub_class_name}
                    </span>
                )}
            </td>
            {can_edit && (
                <td className="px-3 py-2.5">
                    <div className="flex items-center justify-end gap-3">
                        <button
                            type="button"
                            onClick={() => onViewDetail(item)}
                            style={{ width: 28, height: 28 }}
                            className="flex flex-center rounded-full border border-color-200 hover:border-indigo-400 hover:background-100 text-color-400 hover:text-indigo-600">
                            <FiChevronsRight size={16}/>
                        </button>
                        {renderContextMenu(item)}
                    </div>
                </td>
            )}
        </tr>
    )
}

const CourseClassStudentTab = ({}) => {
    const t = useTranslate()

    const {item} = useContext(CourseClassContext)
    const [sub_class_name, setSubClassName] = useState()
    const [subject_id, setSubjectId] = useState()
    const [keyword, setKeyword] = useState()
    const [showMore, setShowMore] = useState(false)

    const can_edit = item?.edit
    const [showSummary, setShowSummary] = useState(false)
    const [showStudentCards, setShowStudentCards] = useState(false)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course_class_id = getId(item)

    const apiInfo = course_getCourseClassStudents_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path.replace(':id', course_class_id),
            sub_class_name,
            subject_id,
            keyword
        ].join('/'),
        [course_class_id, sub_class_name, subject_id, keyword]
    )

    const hasAdvancedFilters = useMemo(() => !!(
        subject_id || sub_class_name
    ), [
        subject_id, sub_class_name
    ])

    const onCancel = () => {
        setAction({})
    }

    const onError = notifyOnError(t)
    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onCancel();
        },
    })

    const modal = useMemo(() => {
        const {student} = action?.value ?? {}
        const id = getId(student)
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {}
        let modal_params = {}

        switch (action?.type) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                return (
                    <FullSideModalLayout
                        right={true}
                        onCancel={onCancel}
                        title={createModalTitle('attendance tracking')}>
                        <CourseClassStudentAttendantsForm
                            courseClass={item}
                            student={student}
                        />
                    </FullSideModalLayout>
                )
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                params = {
                    courseClassStudent: action?.value,
                    course: item,
                    source: 'CourseClassStudentTab',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                    title: (
                        <div className="text-center font-bold text-sm text-color-000 uppercase">
                            {t('update student information in the class')}
                        </div>
                    ),
                }
                Content = CourseClassStudentUpdateModal
                break
            case CRUD.READ:
                // Dùng CHUNG StudentViewCard (5 tab: Thông tin cơ bản/Xác minh danh tính/Khóa học &
                // Chứng chỉ/Kết quả môn học/Lịch sử hoạt động) - đúng component đã dùng ở
                // useStudentForm.js (StudentActionTypes.STUDENT_DETAIL), thay cho DetailModalContent
                // cũ (3 tab, thiết kế cũ) - tránh 2 màn hình chi tiết học viên khác nhau cho cùng 1
                // loại dữ liệu. FetchStudentById là ĐÚNG nguồn dữ liệu StudentViewCard cần (`item`).
                modal_params = {
                    width: 640,
                    footer: undefined,
                    cancelText: t('close'),
                    okButtonProps: {
                        hidden: true,
                    },
                    cancelButtonProps: {
                        className: 'text-color-400 button-rounded-lg no-border',
                    },
                    title: (
                        <div className="text-center font-bold text-sm md:text-lg text-color-000 uppercase">
                            {t('student information')}
                        </div>
                    ),
                }
                Content = StudentViewCard
                Wrapper = withProps({id})(FetchStudentById)
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action])

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update info in course',
                        key: StudentActionTypes.STUDENT_IN_COURSE_UPDATE,
                    },
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendance tracking',
                        key: StudentActionTypes.STUDENT_ATTENDANCE_TRACKING,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                },
                {
                    // Icon mặc định (DefaultIcon) chỉ borderRadius:999 nhưng KHÔNG có nền/viền nên
                    // nhìn không ra hình tròn - background-100 cũng gần như không thấy được (quá gần
                    // màu nền trắng của bảng) nên dùng VIỀN để luôn thấy rõ khung tròn dù nền gì.
                    icon: (
                        <div style={{width: 28, height: 28, borderRadius: 999}}
                            className="flex flex-center border border-color-200 hover:border-indigo-400 hover:background-100 text-color-400 hover:text-indigo-600 cursor-pointer">
                            <BsThreeDots size={13}/>
                        </div>
                    ),
                }
            ),
        []
    )

    return (
        <div className="flex flex-col gap-3">
            {/* Tab "Học viên" giờ đã ẩn hẳn với người không có quyền edit (courseClassRouteEntities.js
                isInvisible) - box này chỉ còn tác dụng nhắc lại phạm vi sử dụng, mirror đúng box đã
                có ở CourseClassAttendanceTab.js (cùng style bg-indigo-50) cho đồng bộ giữa các tab
                quản trị (Học viên/Điểm danh/Điểm số). */}
            {can_edit && (
                <div className="px-3 py-2 flex items-center gap-2 bg-indigo-50 border border-indigo-100 rounded-lg">
                    <BsPeopleFill size={14} className="text-indigo-500 flex-shrink-0"/>
                    <span className="text-xs text-indigo-700 leading-snug">
                        {t('students tab admin description')}
                    </span>
                </div>
            )}
            {/* Trước đây "Thẻ học viên"/"Đánh giá cuối kỳ" là 2 tab riêng cạnh "Danh sách học viên",
                giờ gộp vào 1 menu (chỉ admin thấy) - click mở full modal tương ứng, đúng cách
                "Đánh giá cuối kỳ" đã làm sẵn (showSummary), áp dụng luôn cho "Thẻ học viên". */}
            {can_edit && (
                <div className="flex items-center justify-between gap-2">
                    <div className="flex flex-col">
                        <span className="font-semibold text-base text-gray-700 tracking-wide">
                            {t('list of students')}
                        </span>
                        <div className="w-20 mt-1 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <Dropdown
                        menu={{
                            items: [
                                {key: 'student-card', icon: <FaIdCard size={13} className="text-secondary-400"/>, label: t('student card')},
                                {key: 'assessment', icon: <TbTableOptions size={13} className="text-green-500"/>, label: t('final assessment')},
                            ],
                            onClick: ({key}) => {
                                if (key === 'student-card') setShowStudentCards(true)
                                if (key === 'assessment') setShowSummary(true)
                            },
                        }}
                        trigger={['click']}
                        placement="bottomRight">
                        <button className="w-8 h-8 flex flex-center rounded-full border border-color-200 hover:border-indigo-400 hover:background-100 text-color-400 hover:text-indigo-600">
                            <FiMoreVertical size={18}/>
                        </button>
                    </Dropdown>
                </div>
            )}

            <div className="flex flex-col gap-3 py-1">
                <div className="flex items-center gap-2">
                    <Input
                        placeholder={t('search by student name')}
                        allowClear
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value || undefined)}
                        onClear={() => setKeyword(null)}
                        prefix={<RiSearchLine size={14} className="text-color-400"/>}
                        size="large"
                        className="flex-1 rounded-lg"
                    />
                    <button
                        type="button"
                        onClick={() => setShowMore((v) => !v)}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: '0.5rem',
                            cursor: 'pointer',
                            position: 'relative'
                        }}
                        className={classNames(
                            "flex flex-center transition-all border duration-300",
                            (showMore || hasAdvancedFilters) ?
                                'bg-blue-600 border-blue-600 text-white' :
                                'hover:scale-96 background hover:bg-blue-100 border-blue-300 hover:border-blue-500 text-blue-400 hover:text-blue-500'
                        )}>
                        <FaFilter size={16} className="transition-transform duration-200"/>
                        {hasAdvancedFilters && (
                            <span style={{top: -3, right: -3}} className="w-3 h-3 rounded-full bg-primary border-2 border-white absolute"/>
                        )}
                    </button>
                </div>
                {/* Collapsible advanced filters */}
                {showMore && (
                    <div style={{'--filter-advance-border': '#3182ce'}} className="p-3 flex flex-col gap-4 shadow-md mass-time-filter-advance">
                        {_.get(item, 'class_subjects', []).length > 0 && (
                            <div className="flex flex-col gap-1.5">
                                <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                                    {t('subjects')}
                                </span>
                                <div className="flex flex-wrap gap-1.5">
                                    {_.get(item, 'class_subjects', []).map((_subj, i) => {
                                        const subj = _subj?.subject || _subj;
                                        const id = getId(subj)
                                        const isSelected = subject_id === id
                                        return (
                                            <span
                                                key={i}
                                                className={classNames(
                                                    "px-3 py-1 text-xs font-medium rounded-lg border transition-colors cursor-pointer select-none",
                                                    isSelected
                                                        ? "bg-indigo-600 border-indigo-600 text-white"
                                                        : "background border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500"
                                                )}
                                                onClick={() => setSubjectId(isSelected ? null : id)}>
                                        {getTitle(subj)}
                                    </span>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                        <SubClassTags
                            label={`${t('subclass title')} :`}
                            items={_.get(item, "sub_class_names", [])}
                            selected={sub_class_name}
                            setSelected={setSubClassName}
                        />
                    </div>
                )}
                {/* Bảng 2 cột dùng chung cho học viên + quản trị (khác trước đây: 2 view rời rạc) -
                    cột thao tác (xem chi tiết/menu) chỉ hiện khi can_edit. */}
                <div className="w-full overflow-x-auto">
                    <table className="w-full" style={{borderCollapse: 'collapse'}}>
                        <thead>
                            <tr className="background-200">
                                <th className="px-3 py-2 text-left text-2xs font-bold text-color-400 uppercase tracking-wider">
                                    {t('student')}
                                </th>
                                <th className="px-3 py-2 text-center text-2xs font-bold text-color-400 uppercase tracking-wider">
                                    {t('subclass title')}
                                </th>
                                {can_edit && <th className="px-3 py-2" style={{width: 96}}/>}
                            </tr>
                        </thead>
                        <EntityList
                            key={refreshKey}
                            apiInfo={apiInfo}
                            refreshKey={refreshKey}
                            RenderEntity={React.Fragment}
                            PaginationMeta={EntityPaginationMeta}
                            query={bindQueryParam({id: course_class_id})}
                            values={{sub_class_name, subject_id, keyword, sort_by: 'name asc'}}
                            renderItem={renderStudentTableRow({
                                can_edit,
                                renderContextMenu,
                                onViewDetail: (item) => setAction({type: CRUD.READ, value: item}),
                            })}
                            renderWrap={(children) => (
                                <tbody>{children}</tbody>
                            )}
                        />
                    </table>
                </div>
            </div>

            {can_edit && modal}
            {showSummary && (
                <FullSideModalLayout
                    full={true}
                    title={
                        <div className="flex items-center gap-2">
                            <TbTableOptions size={16} className="text-green-600"/>
                            <span className="font-bold text-color-000">{t('final assessment')}</span>
                        </div>
                    }
                    onCancel={() => setShowSummary(false)}>
                    <div className="p-4">
                        <CourseClassSummaryPanel course_class_id={course_class_id} titleClass={item.title}/>
                    </div>
                </FullSideModalLayout>
            )}
            {showStudentCards && (
                <FullSideModalLayout
                    full={true}
                    title={
                        <div className="flex items-center gap-2">
                            <FaIdCard size={16} className="text-indigo-600"/>
                            <span className="font-bold text-color-000">{t('student card')}</span>
                        </div>
                    }
                    onCancel={() => setShowStudentCards(false)}>
                    <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-6">
                        <EntityList
                            key={refreshKey}
                            apiInfo={apiInfo}
                            refreshKey={refreshKey}
                            RenderEntity={React.Fragment}
                            PaginationMeta={EntityPaginationMeta}
                            query={bindQueryParam({id: course_class_id})}
                            renderItem={renderStudentCard({course_class: item})}
                        />
                    </div>
                </FullSideModalLayout>
            )}
        </div>
    )
}

export default CourseClassStudentTab
